import { Navigate } from "react-router-dom";

export const DocumentPage = () => <Navigate to="/documents" replace />;
